import React from 'react';
import './RightSideMenu.css';
import { NavLink } from 'react-router-dom';

const RightSideMenu = () => {
  return (
    <div className='container-fluid' id='right-side-menu'>
      <div className="row logo-row">
        <img src="Images/logo.png" alt="" />
      </div>
      <div className='hr-line'></div>
      <div className="row list-row">
        <ul>
            <NavLink to="/" className="list">Home</NavLink>
            <NavLink to="/services" className="list">Services</NavLink>
            <NavLink to="/gallery" className="list">Gallery</NavLink>
            <NavLink to="/about-us" className="list">About Us</NavLink>
            <NavLink to="/career" className="list">Career</NavLink>
            <div className='hr-line'></div>
            <NavLink to="/contact-us" className="list">Contact Us</NavLink>
            <NavLink to="/login" className="list">Projects</NavLink>
        </ul>
      </div>
    </div>
  )
}

export default RightSideMenu
